import React from 'react';
import { Link } from 'react-router-dom';
import { StatCard } from './StatCard';
interface ProfileSummaryProps {
  view: 'brand' | 'organizer';
  name: string;
  stats: {
    matches: string | number;
    openDeals: string | number;
    activeCampaigns: string | number;
    avgMatch: string;
  };
}
export function ProfileSummary({
  view,
  name,
  stats
}: ProfileSummaryProps) {
  return <div className="space-y-4" data-id="element-316">
      <div className="flex items-center gap-3" data-id="element-317">
        <div className="w-12 h-12 rounded-lg bg-violet-50 flex items-center justify-center text-violet-600 font-semibold text-lg" data-id="element-318">
          {name.substring(0, 2).toUpperCase()}
        </div>
        <div data-id="element-319">
          <div className="text-sm font-medium text-gray-900" data-id="element-320">
            {view === 'brand' ? 'Brand' : 'Event'}: {name}
          </div>
          <div className="text-xs text-gray-500" data-id="element-321">Last updated recently</div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3" data-id="element-322">
        <StatCard title="Matches" value={stats.matches} data-id="element-323" />
        <StatCard title="Open Deals" value={stats.openDeals} data-id="element-324" />
        <StatCard title="Active" value={stats.activeCampaigns} data-id="element-325" />
        <StatCard title="Avg. Match" value={stats.avgMatch} data-id="element-326" />
      </div>

      <div className="pt-2" data-id="element-327">
        <Link to={view === 'brand' ? '/onboarding/brand' : '/onboarding/organizer'} className="block w-full py-2 rounded-xl bg-violet-600 text-white text-sm text-center font-medium hover:bg-violet-700 transition-colors" data-id="element-328">
          Edit {view === 'brand' ? 'Profile' : 'Event'}
        </Link>
      </div>
    </div>;
}